import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import {Outlet} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import SummaryApi from './common';
import { useEffect, useState } from 'react';
import Context from './context';
import { useDispatch } from 'react-redux';
import { setUserDetails } from './store/userSlice';

function App() {
  const dispatch = useDispatch()
  const [cartProductCount, setCartProductCount] = useState(0)

  const fetchUserDetails = async()=>{
    const dataResponse = await fetch(SummaryApi.current_user.url, {
      method: SummaryApi.current_user.method,
      credentials: 'include'
    })

    if(!dataResponse.ok) throw new Error("Failed to fetch User details")
    const dataApi = await dataResponse.json()
    if(dataApi.success){
      dispatch(setUserDetails(dataApi.data))
    }
    console.log("data-user", dataResponse)
  }

  const fetchUserAddToCart = async()=>{
    const dataResponse = await fetch(SummaryApi.addToCartProductCount.url, {
      method: SummaryApi.addToCartProductCount.method,
      credentials: 'include'
    })

    const dataApi = await dataResponse.json()
    // console.log("dataApi", dataApi)
    setCartProductCount(dataApi?.data?.count)
  }

  useEffect(() =>{
    // user details
    fetchUserDetails();
    //user cart product details
    fetchUserAddToCart()
  }, []); 

  return (
    <>
    <Context.Provider value={{
      fetchUserDetails,
      cartProductCount, //current user cart product count
      fetchUserAddToCart,
    }}>
      <ToastContainer
        position='top-center'
      />
      <Header/>
      <main className='min-h-[calc(100vh-120px)] pt-16'>
        <Outlet/>
      </main>
      <Footer/>
    </Context.Provider>
    </>
  );
}

export default App;